const getMediaItemsInGallery = (mediaItems, galleryId) => {
  let retVal = []
  if (mediaItems) {
    mediaItems.forEach(item => {
      if (item.mediaTypeId === 6) {
        //galleries.push(item)
      }
    })
  }
  return retVal
}

const getGalleries = (mediaItems, selectedGallery) => {
  let galleries = []
  if (mediaItems)
    mediaItems.forEach(item => {
      if (item.mediaTypeId === 6) {
        if (selectedGallery == null || item.id !== selectedGallery.id) {
          galleries.push(item)
        }
      }
    })
  return galleries
}

const getMediaWithoutGalleries = mediaItems => {
  let media = []
  if (mediaItems)
    mediaItems.forEach(item => {
      if (item.mediaTypeId !== 6) {
        media.push(item)
      }
    })
  return media
}

const getAvailableGalleries = (allGalleries, mediaItemsParentGalleries) => {
  let galleries = JSON.parse(JSON.stringify(allGalleries)) // deep clone

  if (mediaItemsParentGalleries)
    mediaItemsParentGalleries.forEach(gallery => {
      galleries.splice(
        galleries.indexOf(galleries.find(e => e.id == gallery.id)),
        1
      )
    })

  return galleries
}

export default {
  getGalleries,
  getMediaWithoutGalleries,
  getAvailableGalleries,
  getMediaItemsInGallery
}
